export const UPDATE_QUOTE = "UPDATE_QUOTE";
export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS";
export const UPDATE_QUOTE_ERROR = "UPDATE_QUOTE_ERROR";
export const UPDATE_QUOTE_CLEAR_DATA = "UPDATE_QUOTE_CLEAR_DATA";
export const PATCH_QUOTE = "PATCH_QUOTE";
export const PATCH_QUOTE_SUCCESS = "PATCH_QUOTE_SUCCESS";
export const PATCH_QUOTE_ERROR = "PATCH_QUOTE_ERROR";
export const PATCH_QUOTE_CLEAR_DATA = "PATCH_QUOTE_CLEAR_DATA";